import {z} from '@hono/zod-openapi';

export const ArticleStatisticsParamsSchema = z
  .object({
    warehouseId: z.string().uuid(),
    articleId: z.string().uuid(),
  })
  .openapi('ArticleStatisticsParams');

export type ArticleStatisticsParams = z.infer<typeof ArticleStatisticsParamsSchema>;
